export const STAGING_ENTRIES_IDS = {
  ABOUT_PAGE: '7tpW3lNdFAJctu7oxEBmtm',
  AUTH_HOMEPAGE: '7tl3GBadUVm2G2WyawK7ZM',
  DISTRIBUTION_ODDS: '6TFcnKuvX0CG9rjwTnBIou',
  DROP_MISSES: '4uRTbxSMSmzXkEcPeHdaHN',
  HOMEPAGE: '01fLMaSgu0TeIzdrGkiJz0',
  MARKETPLACE: '1xbVFkx70ytCPZnDjRpr4X',
  PACK_DETAILS: '4UVOPhm00oohzNzddImMUT',
  PRIVACY_POLICY: '2ZTvePD7ehTm4kNvAWlHCl',
  STOREFRONT: '2OjOuGiDfbNIGPV1wXHX5h',
  TERMS_OF_SERVICE: '7GclaWMJPEg3WpbqneJtwA',
  THIS_WEEK_DROPS: '5lZR52k7Camvq9vnteOGAb',
  UNAUTH_HOMEPAGE: 'IPkgW9n5DfcbAL92nzoGt',
  FOOTER: '7fEAcURdLsU1f8j2YmEICc',
};

export const PRODUCTION_ENTRIES_IDS = {
  ABOUT_PAGE: '7tpW3lNdFAJctu7oxEBmtm',
  AUTH_HOMEPAGE: '11eYLaQHenOaeUGMiAyYOI',
  DISTRIBUTION_ODDS: '44xWV2UQ8NoYyNlvO0FEv8',
  DROP_MISSES: '1U3HVlBtLVtpC0oHx3CTAU',
  HOMEPAGE: '01fLMaSgu0TeIzdrGkiJz0',
  MARKETPLACE: '2K1AMzNHAN7hWtlsn9i0ni',
  PACK_DETAILS: '2tMWEkVQTuKia3heYoIS0P',
  PRIVACY_POLICY: 'M58sRxT1KjdzHJWzcMTCT',
  STOREFRONT: '1tCx1HwHCJ7zopIZiLj1yr',
  TERMS_OF_SERVICE: '9DPewuZGIzWDWVTVn0OEB',
  THIS_WEEK_DROPS: '8fHg7NDTU9uJWhxc2G0bj',
  UNAUTH_HOMEPAGE: 'DEsYacTjzV4Fkb4jhMROR',
  FOOTER: '7fEAcURdLsU1f8j2YmEICc',
};

export const STAGING_CONTENT_TYPE_IDS = {
  DROP: 'drop',
};

export const PRODUCTION_CONTENT_TYPE_IDS = {
  DROP: 'drop',
};

export const DROP_STATUS = {
  CURRENT: 'current',
  FUTURE: 'future',
  PAST: 'past',
};

export enum MediaContentType {
  IMAGE = 'image',
  VIDEO = 'video',
}

const isProduction =
  process.env.NEXT_PUBLIC_CONTENTFUL_ENVIRONMENT === 'master';

export const ENTRIES_IDS = isProduction
  ? PRODUCTION_ENTRIES_IDS
  : STAGING_ENTRIES_IDS;

export const CONTENT_TYPE_IDS = isProduction
  ? PRODUCTION_CONTENT_TYPE_IDS
  : STAGING_CONTENT_TYPE_IDS;
